import useOpenState from "../../../hooks/useOpenState";
import Links from "../links";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";

const HeaderLinks = (props) => {
    const [isLinkOpen, openLink, closeLink] = useOpenState(false, false);

    return (
        <>
            <IconButton
                onClick={openLink}
                size="large"
                disableRipple
            >
                <LinkIcon />
            </IconButton>

            <SwipeableDrawer
                anchor={props.site}
                open={isLinkOpen}
                onClose={closeLink}
                onOpen={openLink}
            >
                <Links close={closeLink}/>
            </SwipeableDrawer>
        </>
    );
};

export default HeaderLinks;

HeaderLinks.propTypes = {
    site: PropTypes.oneOf(["left", "right"]),
};

HeaderLinks.defaultProps = {
    site: "right",
};